import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import OptimizedImage from '../ui/OptimizedImage';
import { projects } from '@/projects';
import { useTranslation } from 'react-i18next';
import { getLocalizedText, normalizeLang, sanitizeText } from '@/lib/format';

const ProjectCard = ({ project }: { project: (typeof projects)[number] }) => {
  const { i18n } = useTranslation();
  const lang = normalizeLang(i18n.language);
  const category = getLocalizedText(project.info.category, lang);

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
      viewport={{ once: true }}
      className="group"
    >
      <Link to={`/projects/${project.info.id}`} className="block">
        <div className="w-full h-[440px] overflow-hidden rounded shadow-md bg-[#222222]">
          <OptimizedImage
            src={project.info.cover}
            alt={project.info.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            fallbackSrc="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='3' width='18' height='18' rx='2' ry='2'%3E%3C/rect%3E%3Ccircle cx='8.5' cy='8.5' r='1.5'%3E%3C/circle%3E%3Cpolyline points='21 15 16 10 5 21'%3E%3C/polyline%3E%3C/svg%3E"
          />
        </div>
        <div className="flex justify-between mt-3 px-1 text-sm sm:text-base font-light text-[#D9D9D9] group-hover:text-[#C8102E] transition-colors duration-300">
          <span>{sanitizeText(project.info.title)}</span>
          <span>{sanitizeText(category)}</span>
        </div>
      </Link>
    </motion.div>
  );
};

const ProjectGrid = () => {
  return (
    <section className="bg-[#2A2A2A] py-20">
      <div className="container-custom">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {projects.map((project) => (
            <ProjectCard key={project.slug} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectGrid;
